import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[mat-button]:not(.ai-clear)'
})
export class AiButtonDirective {

  @HostBinding('class.ai-button') true;

}
